import { useState, useEffect } from 'react';
import HeaderBar from "./HeaderBar";
import { useData, usePunishments } from './MemberData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons';
import '../../styles/style.css'

import { ToastContainer, toast } from "react-toastify";
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import axios from 'axios';

let myDiscordID = ''

function PunishmentsPage() {
    const [searchTerm, setSearchTerm] = useState('');
    const { membersData, loading, getMemberInfo, refreshAccessToken, getDiscordMemberInfo } = useData();
    const { membersPunishments, pLoading } = usePunishments();
    const [isConducere, setIsConducere] = useState(false);
    
    useEffect(() => {
        let isConducereTemp = false;
        myDiscordID = Cookies.get('myDiscordID') || '';

        for (let index = 0; index < membersData.length; index++) {
          const member = membersData[index];
          if (member.discordID === myDiscordID && (member.grade === "Director-General" || member.grade === "Director-Adjunct" || member.grade === "Medic-Inspector" || member.grade === "Medic-Chirurg")) {
            isConducereTemp = true;
          }
        }
        setIsConducere(isConducereTemp);
    }, [membersData]);
    
    function getRomaniaDateTime() {
        const options = { timeZone: "Europe/Bucharest", hour12: false };
        const now = new Date();
    
        const day = now.toLocaleString("en-GB", { ...options, day: "2-digit" });
        const month = now.toLocaleString("en-GB", { ...options, month: "2-digit" });
        const year = now.toLocaleString("en-GB", { ...options, year: "numeric" });
    
        const hours = now.toLocaleString("en-GB", { ...options, hour: "2-digit" });
        const minutes = now.toLocaleString("en-GB", { ...options, minute: "2-digit" });
    
        return `${day}/${month}/${year} - ${hours}:${minutes}`;
    }

    const filteredPunishments = membersPunishments
    .filter((punishment) => {
        const searchLower = searchTerm.toLowerCase();
        return (
            String(punishment.callsign).padStart(3, '0').includes(searchLower) ||
            String(getMemberInfo(Number(punishment.callsign), "user_id")).includes(searchLower) ||
            getMemberInfo(Number(punishment.callsign), "full_name").toLowerCase().includes(searchLower)
        );
    })
    
    async function payFW(callsign: number, date: string, reason: string, amount: number) {
        const result = await Swal.fire({
            title: `Esti sigur ca vrei sa platesti Faction Warn-ul?`,
            text: `Aceasta actiune este ireversibila!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Da, continuă",
            cancelButtonText: "Anulează",
            confirmButtonColor: "#D8630F",
        });
    
        if (!result.isConfirmed) {
            toast.info("Ai anulat acțiunea de platire!");
            return;
        }
    
        try {
            let token = Cookies.get("accessToken");
    
            await axios.post('http://panelmedici.fplayt.ro:5000/api/pay-fw', {
                callsign, 
                date: date, 
                type: 'fw', 
                reason: reason,
                discordId: myDiscordID,
                name: `[M-${String(callsign).padStart(3, '0')}] ${getMemberInfo(Number(callsign), 'full_name')}`
            }, { headers: { Authorization: `Bearer ${token}` } });

            await axios.post('http://panelmedici.fplayt.ro:5000/visterie/createLog', {
                type: "ADAUGARE", 
                amount: amount, 
                callsign: getDiscordMemberInfo(myDiscordID, "callsign"), 
                reason: `Plata FW [M-${String(callsign).padStart(3, '0')}]`, 
                from_callsign: callsign, 
                timestamp: getRomaniaDateTime() 
            }, { headers: { Authorization: `Bearer ${token}` } })

            const response = await axios.get("http://panelmedici.fplayt.ro:5000/visterie/get");
        
            if (response && response.data) {
                axios.post("http://panelmedici.fplayt.ro:5000/visterie/updateVisterie", {
                    money: Number(response.data[0].money)+Number(amount),
                }, { headers: { Authorization: `Bearer ${token}` } })
            }
    
            toast.success(`Ai platit FW-ul lui [M-${callsign?.toString().padStart(3, '0')}]`);
        } catch (error) {
            if ((error as any).response && (error as any).response.status === 401) {
    
                const newAccessToken = await refreshAccessToken();
    
                if (newAccessToken) {
                    await axios.post('http://panelmedici.fplayt.ro:5000/api/pay-fw', {
                        callsign, 
                        date: date, 
                        type: 'fw', 
                        reason: reason,
                        discordId: myDiscordID,
                        name: `[M-${String(callsign).padStart(3, '0')}] ${getMemberInfo(Number(callsign), 'full_name')}`
                    }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
                    await axios.post('http://panelmedici.fplayt.ro:5000/visterie/createLog', {
                        type: "ADAUGARE", 
                        amount: amount, 
                        callsign: getDiscordMemberInfo(myDiscordID, "callsign"), 
                        reason: `Plata FW [M-${String(callsign).padStart(3, '0')}]`, 
                        from_callsign: callsign, 
                        timestamp: getRomaniaDateTime() 
                    }, { headers: { Authorization: `Bearer ${newAccessToken}` } })
        
                    const response = await axios.get("http://panelmedici.fplayt.ro:5000/visterie/get", {
                        headers: { Authorization: `Bearer ${newAccessToken}` }});
                
                    if (response && response.data) {
                        axios.post("http://panelmedici.fplayt.ro:5000/visterie/updateVisterie", {
                            money: Number(response.data[0].money)+Number(amount),
                            type: "ADAUGARE",
                            full_name: getDiscordMemberInfo(myDiscordID, 'full_name'),
                            callsign: callsign,
                            reason: `Plata FW [M-${String(callsign).padStart(3, '0')}]`,
                            amount: Number(amount)
                        }, { headers: { Authorization: `Bearer ${newAccessToken}` } })
                    }
                    toast.success(`Ai platit FW-ul lui [M-${callsign?.toString().padStart(3, '0')}]`);
                }
            } else {
                console.error("Error paying FW: ", error);
                toast.error("A apărut o eroare la plata FW!");
            }
        }
    }

    async function payFine(callsign: number, date: string, reason: string, amount: number) {
        const result = await Swal.fire({
            title: `Esti sigur ca vrei sa platesti Amenda?`,
            text: `Aceasta actiune este ireversibila!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Da, continuă",
            cancelButtonText: "Anulează",
            confirmButtonColor: "#D8630F",
        });
    
        if (!result.isConfirmed) {
            toast.info("Ai anulat acțiunea de platire!");
            return;
        }
    
        try {
            let token = Cookies.get("accessToken");
    
            await axios.post('http://panelmedici.fplayt.ro:5000/api/pay-fw', {
                callsign, 
                date: date, 
                type: 'fine', 
                reason: reason,
                discordId: myDiscordID,
                name: `[M-${String(callsign).padStart(3, '0')}] ${getMemberInfo(Number(callsign), 'full_name')}`
            }, { headers: { Authorization: `Bearer ${token}` } });
            await axios.post('http://panelmedici.fplayt.ro:5000/visterie/createLog', {
                type: "ADAUGARE", 
                amount: amount, 
                callsign: getDiscordMemberInfo(myDiscordID, "callsign"), 
                reason: `Plata Amenda [M-${String(callsign).padStart(3, '0')}]`, 
                from_callsign: callsign, 
                timestamp: getRomaniaDateTime() 
            }, { headers: { Authorization: `Bearer ${token}` } })

            const response = await axios.get("http://panelmedici.fplayt.ro:5000/visterie/get", {
                headers: { Authorization: `Bearer ${token}` }});
        
            if (response && response.data) {
                axios.post("http://panelmedici.fplayt.ro:5000/visterie/updateVisterie", {
                    money: Number(response.data[0].money)+Number(amount),
                    type: "ADAUGARE",
                    full_name: getDiscordMemberInfo(myDiscordID, 'full_name'),
                    callsign: callsign,
                    reason: `Plata Amenda [M-${String(callsign).padStart(3, '0')}]`,
                    amount: Number(amount)
                }, { headers: { Authorization: `Bearer ${token}` } })
            }
            toast.success(`Ai platit Amenda-ul lui [M-${callsign?.toString().padStart(3, '0')}]`);
        } catch (error) {
            if ((error as any).response && (error as any).response.status === 401) {
    
                const newAccessToken = await refreshAccessToken();
    
                if (newAccessToken) {
                    await axios.post('http://panelmedici.fplayt.ro:5000/api/pay-fw', {
                        callsign, 
                        date: date, 
                        type: 'fine', 
                        reason: reason,
                        discordId: myDiscordID,
                        name: `[M-${String(callsign).padStart(3, '0')}] ${getMemberInfo(Number(callsign), 'full_name')}`
                    }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
                    await axios.post('http://panelmedici.fplayt.ro:5000/visterie/createLog', {
                        type: "ADAUGARE", 
                        amount: amount, 
                        callsign: getDiscordMemberInfo(myDiscordID, "callsign"), 
                        reason: `Plata FW [M-${String(callsign).padStart(3, '0')}]`, 
                        from_callsign: callsign, 
                        timestamp: getRomaniaDateTime() 
                    }, { headers: { Authorization: `Bearer ${newAccessToken}` } })
        
                    const response = await axios.get("http://panelmedici.fplayt.ro:5000/visterie/get", {
                        headers: { Authorization: `Bearer ${newAccessToken}` }});                
                    if (response && response.data) {
                        axios.post("http://panelmedici.fplayt.ro:5000/visterie/updateVisterie", {
                            money: Number(response.data[0].money)+Number(amount),
                            type: "ADAUGARE",
                            full_name: getDiscordMemberInfo(myDiscordID, 'full_name'),
                            callsign: callsign,
                            reason: `Plata Amenda [M-${String(callsign).padStart(3, '0')}]`,
                            amount: Number(amount)
                        }, { headers: { Authorization: `Bearer ${newAccessToken}` } })
                    }
                    toast.success(`Ai platit Amenda-ul lui [M-${callsign?.toString().padStart(3, '0')}]`);
                }
            } else {
                console.error("Error paying Fine: ", error);
                toast.error("A apărut o eroare la plata Amendei!");
            }
        }
    }
    

    async function deletePunishment(callsign: number, date: string, reason: string, amount: number, type: string) {
        const result = await Swal.fire({
            title: `Esti sigur ca vrei sa stergi ${type === 'fw' ? "FW-ul" : "AMENDA"}?`,
            text: `Aceasta actiune este ireversibila!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Da, continuă",
            cancelButtonText: "Anulează",
            confirmButtonColor: "#D8630F",
        });
    
        if (!result.isConfirmed) {
            toast.info("Ai anulat acțiunea de stergere!");
            return;
        }
    
        try {
            let token = Cookies.get("accessToken");
    
            await axios.post("http://panelmedici.fplayt.ro:5000/punishment/delete", {
                callsign: callsign,
                date: date,
                reason: reason,
                amount: amount,
                type: type
            }, { headers: { Authorization: `Bearer ${token}` } });
            toast.success("Ai sters cu succes sancțiunea!");
        } catch (error) {
            if ((error as any).response && (error as any).response.status === 401) {
    
                const newAccessToken = await refreshAccessToken();
    
                if (newAccessToken) {
                    await axios.post("http://panelmedici.fplayt.ro:5000/punishment/delete", {
                        callsign: callsign,
                        date: date,
                        reason: reason,
                        amount: amount,
                        type: type
                    }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
                    toast.success("Ai sters cu succes sancțiunea!");
                }
            } else {
                console.error("Error deleting punishment: ", error);
                toast.error("A apărut o eroare la ștergerea amenzii!");
            }
        }
    }
    
    if (loading || pLoading) {
        return (
          <div className="w-full h-full flex flex-col">
            <HeaderBar currentPage="Sanctiuni"/>
            <div className="w-[99%] h-[87%] box-border p-[1%] pt-[0.5%] bg-[rgba(255,255,255,0.61)] dark:bg-[#605D5D61] flex flex-col gap-[1%] backdrop-blur-[32px] rounded-[1vw]">
              <div className="w-full h-full flex items-center justify-between">
                <span className="w-full textExtraBold text-[#323232] text-[2vw] flex items-center justify-center">Pagina se incarca!</span>
              </div>
            </div>
          </div>
        );
    }

    return (
        <div className="w-full h-full flex flex-col">
            <HeaderBar currentPage="Sanctiuni"/>
            <div className="w-[99%] h-[87%] box-border p-[1%] pt-[0.5%] bg-[rgba(255,255,255,0.61)] dark:bg-[#605D5D61] flex flex-col gap-[1%] backdrop-blur-[32px] rounded-[1vw]">
                <div className="w-full h-[7%] flex items-center justify-between">
                    <span className="textSemiBold text-[1.1vw] text-[#000000] dark:text-[#ffffff]">Listă Sancțiuni</span>
                    {/* <div className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                        <span className="textBold text-white text-[.8vw]">VERIFICA SANCTIUNI</span>
                    </div> */}
                    <div className="bg-[#00000010] dark:bg-[#ffffff10] border border-[#00000020] dark:border-[#ffffff20] w-[15%] h-[90%] rounded-full flex items-center justify-between box-border px-[1%]">
                        <input
                            type="text"
                            placeholder="Caută sancțiune (callsign)"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="pb-[1%] text-[#00000050] dark:text-[#ffffff50] dark:placeholder-[#ffffff50] placeholder-[#00000050] placeholder:text-[0.8vw] text-[0.8vw] bg-transparent h-full border-none outline-none"
                        />
                        <FontAwesomeIcon className="text-[#00000050] dark:text-[#ffffff50] text-[0.8vw]" icon={faMagnifyingGlass} />
                    </div>
                </div>
                <div className="bg-white dark:bg-[#323232] w-full h-[93%] rounded-xl flex flex-col overflow-y-scroll">
                    {Array.isArray(filteredPunishments) && filteredPunishments.length > 0 && (
                        filteredPunishments.map((punishment, index) => (
                        <div
                            key={index}
                            className="w-full min-h-[7%] flex items-center gap-[1%] box-border pl-[1%] pr-[1%] border-b-[1px] border-[#D0D0D0]"
                        >
                            <span className="textSemiBold w-[3%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                                {getMemberInfo(Number(punishment.callsign), "user_id")}
                            </span>
                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            <span className="textSemiBold w-[5%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                                [M-{String(punishment.callsign).padStart(3, '0')}]
                            </span>
                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            <span className="textSemiBold w-[10%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                                {getMemberInfo(Number(punishment.callsign), "full_name")}
                            </span>
                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            <span className="textSemiBold w-[5%] text-center text-red-500 text-[0.9vw]">
                                {JSON.parse(punishment.punishments).pType.toUpperCase()}
                            </span>
                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            <span className="textSemiBold w-[20%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                                {JSON.parse(punishment.punishments).reason}
                            </span>
                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            <span className="textSemiBold w-[5%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                                {String(JSON.parse(punishment.punishments).amount).replace(/(.)(?=(\d{3})+$)/g,'$1,')}$
                            </span>
                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            <span className="textSemiBold w-[5%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                                {JSON.parse(punishment.punishments).date}
                            </span>
                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            <span className="textSemiBold w-[5%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                                {JSON.parse(punishment.punishments).hr}
                            </span>
                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            {JSON.parse(punishment.punishments).pType.toUpperCase() !== "FW" && (
                                <span className="textSemiBold w-[8%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                                    EXP: {JSON.parse(punishment.punishments).expire}
                                </span>
                            )}
                            {JSON.parse(punishment.punishments).status === false ? (
                                isConducere === false ? (
                                    JSON.parse(punishment.punishments).pType.toUpperCase() === "AMENDA" ? (
                                        <div className="w-[16%] h-full flex items-center justify-end">
                                            <div className="w-[39%] h-[70%] px-[1%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#ad0a0a] to-[#f51818]">
                                                <span className="textBold text-white text-[.8vw]">NEPLĂTIT</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="w-[25%] h-full flex items-center justify-end">
                                            <div className="w-[25%] h-[70%] px-[1%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#ad0a0a] to-[#f51818]">
                                                <span className="textBold text-white text-[.8vw]">NEPLĂTIT</span>
                                            </div>
                                        </div>
                                    )
                                ) : JSON.parse(punishment.punishments).pType.toUpperCase() === "FW" ? (
                                    <div className="w-[25%] h-full flex items-center justify-end">
                                        <div
                                            onClick={() => payFW(Number(punishment.callsign), JSON.parse(punishment.punishments).date, JSON.parse(punishment.punishments).reason, JSON.parse(punishment.punishments).amount)}
                                            className="w-[25%] h-[70%] px-[1%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]"
                                        >
                                            <span className="textBold text-white text-[.8vw]">PLĂTEȘTE</span>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="w-[16%] h-full flex items-center justify-end">
                                        <div
                                            onClick={() => payFine(Number(punishment.callsign), JSON.parse(punishment.punishments).date, JSON.parse(punishment.punishments).reason, JSON.parse(punishment.punishments).amount)}
                                            className="w-[39%] h-[70%] px-[1%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]"
                                        >
                                            <span className="textBold text-white text-[.8vw]">PLĂTEȘTE</span>
                                        </div>
                                    </div>
                                )
                            ) : (
                                JSON.parse(punishment.punishments).pType.toUpperCase() === "AMENDA" ? (
                                    <div className="w-[16%] h-full flex items-center justify-end gap-[2%]">
                                        <div className="w-[39%] h-[70%] px-[1%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#367a25] to-[#33b512]">
                                            <span className="textBold text-white text-[.8vw]">PLĂTIT</span>
                                        </div>
                                        {isConducere === true && (
                                            <div onClick={() => deletePunishment(Number(punishment.callsign), JSON.parse(punishment.punishments).date, JSON.parse(punishment.punishments).reason, JSON.parse(punishment.punishments).amount, "fine")} className="w-[13%] h-[70%] bg-[#ff0000ac] flex items-center justify-center rounded-[.2vw] cursor-pointer">
                                                <FontAwesomeIcon className="text-[1vw] text-white" icon={faXmark} />
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div className="w-[25%] h-full flex items-center justify-end gap-[1.4%]">
                                        <div className="w-[25%] h-[70%] px-[1%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#367a25] to-[#33b512]">
                                            <span className="textBold text-white text-[.8vw]">PLĂTIT</span>
                                        </div>
                                        {isConducere === true && (
                                            <div onClick={() => deletePunishment(Number(punishment.callsign), JSON.parse(punishment.punishments).date, JSON.parse(punishment.punishments).reason, JSON.parse(punishment.punishments).amount, "fw")} className="w-[8.4%] h-[70%] bg-[#ff0000ac] flex items-center justify-center rounded-[.2vw] cursor-pointer">
                                                <FontAwesomeIcon className="text-[1vw] text-white" icon={faXmark} />
                                            </div>
                                        )}
                                    </div>
                                )
                            )}
                        </div>
                    )))}
                </div>
            </div>
            <ToastContainer />
        </div>
    );
}

export default PunishmentsPage;